import { render, staticRenderFns } from "./default.vue?vue&type=template&id=5198db74"
import script from "./default.vue?vue&type=script&lang=js"
export * from "./default.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Header: require('/var/www/components/Header/header.vue').default,ModalWrap: require('/var/www/components/modal/modal-wrap.vue').default,ModalBenefits: require('/var/www/components/modal/modal-benefits.vue').default,ModalReceiptVin: require('/var/www/components/modal/modal-receipt-vin.vue').default,Footer: require('/var/www/components/Footer/footer.vue').default,CookieModal: require('/var/www/components/Cookie/Modal.vue').default})
